import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./not-found.component.scss";

export default function NotFoundComponent(): JSX.Element {
  useEffect(() => {
    document.title = "Page not found | sthinds.io";
    return () => {
      document.title = "sthinds.io";
    };
  }, []);

  return (
    <section className="not-found" aria-labelledby="not-found-title">
      <p className="not-found-kicker">404</p>
      <h1 id="not-found-title">This page has moved or does not exist.</h1>
      <p>Try the home page to browse the latest posts.</p>
      <Link to="/" className="not-found-link">
        Back to home
      </Link>
    </section>
  );
}
